import { CHART_TARGETS } from './constants'
import { SeriesItem } from './People'

// Find the index of the item in the series closest to the target radius
export const findClosestIndex = (series: SeriesItem[], target: number): number =>
  series.reduce((minIndex, item, index, arr) => {
    const distance = Math.abs(item.approxRadiusM - target)
    const minDistance = Math.abs(arr[minIndex].approxRadiusM - target)
    return distance < minDistance ? index : minIndex
  }, 0)

// Process the series data to prepare chart data, labels, and point configurations
export const processChartData = (series: SeriesItem[]): {
  data: number[]
  labels: string[]
  pointRadius: number[]
  pointIndex: number
  endIndex: number
} => {
  // Start from the item closest to 500m
  const startIndex = findClosestIndex(series, CHART_TARGETS.START)
  const filteredSeries = series.slice(startIndex)

  // Find index in filtered series closest to 1000m for the point
  const pointIndex = findClosestIndex(filteredSeries, CHART_TARGETS.POINT)
  // Find index in filtered series closest to 1500m for the end label
  const endIndex = findClosestIndex(filteredSeries, CHART_TARGETS.END)

  const data = filteredSeries.map(item => item.total)
  const labels = filteredSeries.map(item => `${Math.round(item.approxRadiusM)}m`)
  const pointRadius = filteredSeries.map((_, index) => (index === pointIndex ? 5 : 0))

  return {
    data,
    labels,
    pointRadius,
    pointIndex,
    endIndex,
  }
}
